import { McsisConstants } from '@/models/constants/McsisConstants';
import moment from 'moment';
import Vue from 'vue';

/**
 * This is a in-memory store. Data are lost on page reload.
 */
export const store = Vue.observable({
  state: {
    token: '',
    tokenTimestamp: 0,
    isIdentified: false,
    screeningUnit: 0,
    dataLoading: false,
    isLanguagesLoaded: false,
    isAppLoaded: false,
    isDirectRefusal: false,
    showErrInfoModal: false,
    popUpErrMessage: '',
    radF: true,
    radM: false,
    appVersion: {
      isLatest: false,
      lastCheckDate: moment().format(McsisConstants.DefaultDateFormat),
    },
    maxVisitedStepNumber: 0,
  },
});

export const mutations = {
  setToken(token: string) {
    store.state.token = token;
  },

  setShowErrInfoModal(status: boolean) {
    store.state.showErrInfoModal = status;
  },

  setPopUpErrMessage(errMsg: string) {
    store.state.popUpErrMessage = errMsg;
  },

  setTokenTimestamp(timestamp: number) {
    store.state.tokenTimestamp = timestamp;
  },

  setIsIdentified(status: boolean) {
    store.state.isIdentified = status;
  },

  setScreeningUnit(suId: number) {
    store.state.screeningUnit = suId;
  },

  setLoadingState(status: boolean) {
    store.state.dataLoading = status;
  },

  setIsLanguagesLoaded(status: boolean) {
    store.state.isLanguagesLoaded = status;
  },

  setIsAppLoaded(value: boolean) {
    store.state.isAppLoaded = value;
  },

  setIsDirectRefusal(value: boolean) {
    store.state.isDirectRefusal = value;
  },

  setAppVersion(value: any) {
    store.state.appVersion = value;
  },

  setMaxVisitedStepNumber(value: number) {
    store.state.maxVisitedStepNumber = value;
  },

  setChoiceRadM(value: boolean) {
    store.state.radM = value;
  },

  setChoiceRadF(value: boolean) {
    store.state.radF = value;
  },
};
